// @ts-nocheck
import { useEffect } from 'react';

/**
 * Centered overlay modal shell. Provides dimmed backdrop + close-on-overlay-click; callers pass
 * header / body / footer as children.
 */
export const CenteredModal = ({
  open,
  onClose,
  maxWidthClass = 'max-w-md',
  zClassName = 'z-50',
  disableBackdropClose = false,
  titleId,
  children,
}) => {
  useEffect(() => {
    if (!open || !onClose || disableBackdropClose) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose, disableBackdropClose]);

  if (!open) return null;
  return (
    <div className={`fixed inset-0 ${zClassName} flex items-center justify-center`}>
      <div
        className="absolute inset-0 bg-black/30 backdrop-blur-[2px]"
        onClick={disableBackdropClose ? undefined : onClose}
        aria-hidden
      />
      <div
        className={`relative bg-white rounded-xl shadow-xl w-full ${maxWidthClass} mx-4 border border-gray-100 overflow-hidden`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId || undefined}
      >
        {children}
      </div>
    </div>
  );
};
